<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <!-- Server validation errors summary -->
  @if (serverErrors.length > 0) {
    <div class="alert alert-danger" role="alert">
      <ul class="mb-0">
        @for (error of serverErrors; track error) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }

  <div class="mb-3">
    <label for="registerEmail" class="form-label">Email *</label>
    <input
      type="email"
      class="form-control"
      id="registerEmail"
      formControlName="email"
      [class.is-invalid]="
        registerForm.get('email')?.invalid && (registerForm.get('email')?.dirty || registerForm.get('email')?.touched)
      "
      [disabled]="isLoading" />
    @if (
      registerForm.get('email')?.invalid && (registerForm.get('email')?.dirty || registerForm.get('email')?.touched)
    ) {
      <div class="invalid-feedback">Please enter a valid email address</div>
    }
  </div>

  <div class="mb-3">
    <label for="registerPassword" class="form-label">Password *</label>
    <input
      type="password"
      class="form-control"
      id="registerPassword"
      formControlName="password"
      [class.is-invalid]="
        registerForm.get('password')?.invalid &&
        (registerForm.get('password')?.dirty || registerForm.get('password')?.touched)
      "
      [disabled]="isLoading" />
    @if (
      registerForm.get('password')?.invalid &&
      (registerForm.get('password')?.dirty || registerForm.get('password')?.touched)
    ) {
      <div class="invalid-feedback">
        Password must be at least 12 characters long and contain lowercase letters, uppercase letters, numbers and
        symbols
      </div>
    }
  </div>

  <div class="mb-3">
    <label for="confirmPassword" class="form-label">Confirm Password</label>
    <input
      type="password"
      class="form-control"
      id="confirmPassword"
      formControlName="confirmPassword"
      [class.is-invalid]="
        (registerForm.get('confirmPassword')?.invalid &&
          (registerForm.get('confirmPassword')?.dirty || registerForm.get('confirmPassword')?.touched)) ||
        (registerForm.hasError('passwordMismatch') &&
          (registerForm.get('confirmPassword')?.dirty || registerForm.get('confirmPassword')?.touched))
      "
      [disabled]="isLoading" />
    @if (
      registerForm.get('confirmPassword')?.invalid &&
      (registerForm.get('confirmPassword')?.dirty || registerForm.get('confirmPassword')?.touched)
    ) {
      <div class="invalid-feedback">Please confirm your password</div>
    }
    @if (
      registerForm.hasError('passwordMismatch') &&
      (registerForm.get('confirmPassword')?.dirty || registerForm.get('confirmPassword')?.touched)
    ) {
      <div class="invalid-feedback">Passwords do not match</div>
    }
  </div>

  <!-- Optional Profile Information -->
  <hr class="my-4" />
  <h6 class="text-muted mb-3">Profile Information</h6>

  <div class="row">
    <div class="col-md-6">
      <div class="mb-3">
        <label for="firstName" class="form-label">First Name *</label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          formControlName="firstName"
          maxlength="100"
          [disabled]="isLoading"
          [class.is-invalid]="registerForm.get('firstName')?.invalid && registerForm.get('firstName')?.touched" />

        <div class="invalid-feedback">Please provide your first name</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="mb-3">
        <label for="lastName" class="form-label">Last Name *</label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          formControlName="lastName"
          maxlength="100"
          [disabled]="isLoading"
          [class.is-invalid]="registerForm.get('lastName')?.invalid && registerForm.get('lastName')?.touched" />

        <div class="invalid-feedback">Please provide your last name</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="mb-3">
        <label for="jobTitle" class="form-label">Job Title</label>
        <input
          type="text"
          class="form-control"
          id="jobTitle"
          formControlName="jobTitle"
          maxlength="150"
          [disabled]="isLoading" />
      </div>
    </div>
    <div class="col-md-6">
      <div class="mb-3">
        <label for="department" class="form-label">Department</label>
        <input
          type="text"
          class="form-control"
          id="department"
          formControlName="department"
          maxlength="150"
          [disabled]="isLoading" />
      </div>
    </div>
  </div>

  <!-- Interests Selection -->
  <div class="mb-3">
    <div class="form-label fw-bold">Areas of Interest</div>
    <div class="form-text mb-2">Select the areas that are relevant to you (you can select multiple):</div>
    @if (userInterests.length > 0) {
      <div class="row">
        @for (interest of userInterests; track interest.id) {
          <div class="col-md-6">
            <div class="form-check mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'interest-' + interest.id"
                [formControlName]="'interest-' + interest.id"
                [disabled]="isLoading" />
              <label class="form-check-label" [for]="'interest-' + interest.id">
                {{ interest.name }}
                @if (interest.description) {
                  <small class="text-muted d-block">{{ interest.description }}</small>
                }
              </label>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="text-muted">Loading interests...</div>
    }
  </div>

  <div class="d-grid gap-2">
    <button type="submit" class="btn btn-primary" [disabled]="registerForm.invalid || isLoading">
      @if (isLoading) {
        <span class="spinner-border spinner-border-sm me-2"></span>
      }
      Create Account
    </button>
  </div>
</form>

@if (showLoginLink) {
  <div class="text-center mt-4">
    <p class="mb-0">
      Already have an account?
      <a href="#" (click)="switchToLogin(); $event.preventDefault()" class="text-decoration-none">Log in here</a>
    </p>
  </div>
}
